module.exports = __webpack_public_path__ + "media/DINPro-Condensed-Bold.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/DINPro-Condensed/DINPro-Condensed-Bold.woff2
// module id = 1569
// module chunks = 57